export default __webpack_public_path__ + "static/media/delphus.eef5872f.png";